import { TradingItemProps } from 'components/molecules/TradingItem/types'
import React from 'react'
import TradingEnvSection from '../../sections/TradingEnvSection'
import { TradingEnvSliceProps } from './types'

const TradingEnvSlice: React.FC<TradingEnvSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { te_title, te_is_main_heading, te_description, te_icon } = primary || {}

  const icon = {
    publicURL: te_icon?.url,
    childImageSharp: te_icon && {
      gatsbyImageData: te_icon.gatsbyImageData
    },
    width: te_icon?.dimensions?.width,
    height: te_icon?.dimensions?.height,
    alt: te_icon?.alt
  }

  const data = items.reduce((data, item, index) => {
    const { te_item_title, te_item_code, te_item_description, te_item_icon } = item || {}

    if (!te_item_icon) {
      return data
    }

    return [
      ...data,
      {
        key: `trading-item-${index}`,
        icon: te_item_icon,
        title: te_item_title?.text || '',
        code: te_item_code,
        content: te_item_description?.text || ''
      }
    ]
  }, [] as TradingItemProps[])

  return (
    <TradingEnvSection
      icon={icon}
      heading={te_title?.text}
      isMainHeading={te_is_main_heading}
      headingPadding={['56px', '', '94px']}
      description={te_description?.html}
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['40px', '', '100px']}
      data={data}
    />
  )
}

export default TradingEnvSlice
